import { compareRows } from "@/mocks/portal";

export default function CompareBoard() {
  return (
    <section id="compare" className="mx-auto max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
          <i className="ri-bar-chart-grouped-line text-sm" aria-hidden="true" />
          Compare
        </span>
        <h2 className="text-lg font-bold text-foreground-950 md:text-2xl">吃瓜线路 · 横向对比</h2>
        <p className="text-xs text-foreground-500 md:text-sm">
          各线路的可达性、延迟与带宽为近一周样本汇总。做线路对比时请横向看，别只盯单列最高值。
        </p>
      </div>

      <div className="mt-6 overflow-x-auto rounded-xl border border-background-200">
        <table className="w-full min-w-[820px] border-collapse bg-background-50 text-left text-sm">
          <thead>
            <tr className="bg-background-100 text-[12px] uppercase tracking-wide text-foreground-500">
              <th className="px-4 py-3 font-semibold md:px-5">线路</th>
              <th className="px-4 py-3 font-semibold md:px-5">类型</th>
              <th className="px-4 py-3 font-semibold md:px-5">节点</th>
              <th className="px-4 py-3 font-semibold md:px-5">延迟</th>
              <th className="px-4 py-3 font-semibold md:px-5">带宽</th>
              <th className="px-4 py-3 font-semibold md:px-5">可用性</th>
              <th className="px-4 py-3 font-semibold md:px-5">适合</th>
              <th className="px-4 py-3 font-semibold md:px-5">参考分</th>
            </tr>
          </thead>
          <tbody>
            {compareRows.map((r) => (
              <tr
                key={r.name}
                className="border-t border-background-200 transition-colors hover:bg-primary-50"
              >
                <td className="px-4 py-3.5 md:px-5">
                  <div className="flex items-center gap-2.5">
                    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-node-tree text-base" aria-hidden="true" />
                    </span>
                    <span className="flex flex-col">
                      <span className="font-semibold text-foreground-950">{r.name}</span>
                      {r.badge && (
                        <span className="mt-0.5 whitespace-nowrap text-[11px] font-medium text-accent-600">
                          <i className="ri-flag-2-line mr-0.5" aria-hidden="true" />
                          {r.badge}
                        </span>
                      )}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-3.5 md:px-5">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900">{r.type}</span>
                </td>
                <td className="font-num px-4 py-3.5 text-foreground-700 md:px-5">{r.nodes}</td>
                <td className="font-num px-4 py-3.5 font-bold text-primary-600 md:px-5">{r.lat}</td>
                <td className="font-num px-4 py-3.5 text-foreground-700 md:px-5">{r.band}</td>
                <td className="font-num px-4 py-3.5 text-foreground-700 md:px-5">{r.stay}</td>
                <td className="px-4 py-3.5 text-[13px] text-foreground-600 md:px-5">{r.use}</td>
                <td className="px-4 py-3.5 md:px-5">
                  <span className="font-num inline-flex items-center gap-1 text-base font-bold text-foreground-950">
                    {r.score.toFixed(1)}
                    <i className="ri-star-fill text-[13px] text-accent-500" aria-hidden="true" />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}